import { render, staticRenderFns } from "./ExitSurvey.vue?vue&type=template&id=571d1e2d"
import script from "./ExitSurvey.vue?vue&type=script&lang=js"
export * from "./ExitSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports